var map = {
	"./ajudar.png": 46,
	"./alcochete_ecoponto.png": 47,
	"./alcochete_embalao.png": 48,
	"./alcochete_ilhas.png": 49,
	"./alcochete_papelao.png": 50,
	"./alcochete_papelaoembalao.png": 51,
	"./alcochete_petao.png": 52,
	"./alcochete_vidrao.png": 53,
	"./alcochete_vidraoembalao.png": 54,
	"./alcochete_vidraopapelao.png": 55,
	"./almada_ecoponto.png": 56,
	"./almada_embalao.png": 57,
	"./almada_ilhas.png": 58,
	"./almada_papelao.png": 59,
	"./almada_papelaoembalao.png": 60,
	"./almada_petao.png": 61,
	"./almada_vidrao.png": 62,
	"./almada_vidraoembalao.png": 63,
	"./almada_vidraopapelao.png": 64,
	"./barreiro_ecoponto.png": 65,
	"./barreiro_embalao.png": 66,
	"./barreiro_ilhas.png": 67,
	"./barreiro_papelao.png": 68,
	"./barreiro_papelaoembalao.png": 69,
	"./barreiro_petao.png": 70,
	"./barreiro_vidrao.png": 71,
	"./barreiro_vidraoembalao.png": 72,
	"./barreiro_vidraopapelao.png": 73,
	"./canceled.png": 74,
	"./ecosound.png": 75,
	"./indiferido.png": 76,
	"./moita_ecoponto.png": 77,
	"./moita_embalao.png": 78,
	"./moita_ilhas.png": 79,
	"./moita_papelao.png": 80,
	"./moita_papelaoembalao.png": 81,
	"./moita_petao.png": 82,
	"./moita_vidrao.png": 83,
	"./moita_vidraoembalao.png": 84,
	"./moita_vidraopapelao.png": 85,
	"./montijo_ecoponto.png": 86,
	"./montijo_embalao.png": 87,
	"./montijo_ilhas.png": 88,
	"./montijo_papelao.png": 89,
	"./montijo_papelaoembalao.png": 90,
	"./montijo_petao.png": 91,
	"./montijo_vidrao.png": 92,
	"./montijo_vidraoembalao.png": 93,
	"./montijo_vidraopapelao.png": 94,
	"./palmela_ecoponto.png": 95,
	"./palmela_embalao.png": 96,
	"./palmela_ilhas.png": 97,
	"./palmela_papelao.png": 98,
	"./palmela_papelaoembalao.png": 99,
	"./palmela_petao.png": 100,
	"./palmela_vidrao.png": 101,
	"./palmela_vidraoembalao.png": 102,
	"./palmela_vidraopapelao.png": 103,
	"./pending.png": 104,
	"./seixal_ecoponto.png": 105,
	"./seixal_embalao.png": 106,
	"./seixal_ilhas.png": 107,
	"./seixal_papelao.png": 108,
	"./seixal_papelaoembalao.png": 109,
	"./seixal_petao.png": 110,
	"./seixal_vidrao.png": 111,
	"./seixal_vidraoembalao.png": 112,
	"./seixal_vidraopapelao.png": 113,
	"./sesimbra_ecoponto.png": 114,
	"./sesimbra_embalao.png": 115,
	"./sesimbra_ilhas.png": 116,
	"./sesimbra_papelao.png": 117,
	"./sesimbra_papelaoembalao.png": 118,
	"./sesimbra_petao.png": 119,
	"./sesimbra_vidrao.png": 120,
	"./sesimbra_vidraoembalao.png": 121,
	"./sesimbra_vidraopapelao.png": 122,
	"./setubal_ecoponto.png": 123,
	"./setubal_embalao.png": 124,
	"./setubal_ilhas.png": 125,
	"./setubal_papelao.png": 126,
	"./setubal_papelaoembalao.png": 127,
	"./setubal_petao.png": 128,
	"./setubal_vidrao.png": 129,
	"./setubal_vidraoembalao.png": 130,
	"./setubal_vidraopapelao.png": 131,
	"./suspended.png": 132
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 169;



//////////////////
// WEBPACK FOOTER
// ./src/ecopontos/icons .*
// module id = 169
// module chunks = 0